export default "__VITE_ASSET__9Kbk$re2__"